module.exports = __webpack_public_path__ + "img/go-with-freedom.3c38c041.png";